import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5f2a7ef0&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style1 from "./list.vue?vue&type=style&index=1&id=5f2a7ef0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a7ef0",
  null
  
)

export default component.exports